import React, { useEffect, useMemo, useRef, useState } from "react";
import { AgGridReact } from "@ag-grid-community/react";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import axios from "axios";
import { apiUrl, assetsUrl } from "../../config/Config";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from "react-bootstrap";
import { GoogleOAuthProvider, GoogleLogin, useGoogleLogin } from "@react-oauth/google";


// Register AG Grid modules
ModuleRegistry.registerModules([ClientSideRowModelModule]);

const PlatformAccountTableTest = () => {
  var sampledata = [
    { platform: "Facebook", status: "false", account: null, accessPages: ['ConsultHagnos India', 'HagnosTech', 'Our BHK'], accesstokens: "" },
    { platform: "Instagram", status: "false", account: null, accessPages: ['HagnosTech', 'Our BHK'], accesstokens: "" },
    { platform: "LinkedIn", status: "false", account: null, accessPages: ['Our BHK'], accesstokens: ""},
    { platform: "Twitter", status: "false", account: null, accessPages: ['ConsultHagnos India'], accesstokens: "" },
    { platform: "Youtube", status: "false", account: null, accessPages: ['ConsultHagnos India'], accesstokens: "" }
  ];
  // LinkedInLogin.jsx
const LINKEDIN_CLIENT_ID = "77eda9q82l9jwo";
const LINKEDIN_REDIRECT_URI = "https://marketing.consulthagnos.in.net/apibackend/apis/auth/linkedin/callback";
const LINKEDIN_SCOPE = "openid profile email rw_organization_admin r_organization_social w_organization_social w_member_social r_organization_admin";

const GOOGLE_CLIENT_ID = "692688476295-sbkqbbmsrcli8h56caf2250prvc5l6lc.apps.googleusercontent.com"; // from Google Cloud
const REDIRECT_URI = "https://marketing.consulthagnos.in.net/apibackend/apis/auth/youtube/callback"; // Laravel route
const SCOPES =
  "https://www.googleapis.com/auth/youtube.upload https://www.googleapis.com/auth/youtube.readonly";

  var sampleplaftormsobj = {
    "Facebook": {},
    "Instagram": {},
    "LinkedIn": {},
    "Twitter": {},
    "Youtube": {}
  }
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [showUpdateUserModal, setShowUpdateUserModal] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState({});
  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState();
  const [showLoading, setShowLoading] = useState(false);
  const [platformsarr, setplatformsarr] = useState([]);
  const platformsarrRef = useRef(null);
  platformsarrRef.current = platformsarr;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [utubeloginmodal, setutubeloginmodal] = useState(false);

  console.log('userdata >>', userdata);

  const [showmodal, setshowmodal] = useState(false);
  const [selectedpageobj, setselectedpageobj] = useState({});
  const selectedpageobjRef = useRef({});
  selectedpageobjRef.current = selectedpageobj;


  const defaultColDef = useMemo(() => ({ flex: 1 }), []);

  const handleLinkedinLogin = () => {
    const stateParam = encodeURIComponent(`${userdata['token']}`);
    const authUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${LINKEDIN_CLIENT_ID}&redirect_uri=${encodeURIComponent(LINKEDIN_REDIRECT_URI)}&scope=${LINKEDIN_SCOPE}&state=${stateParam}&prompt=login`;
    console.log('authUrl >>', authUrl);
    window.location.href = authUrl;
  };

  const logoutFromLinkedIn = async() => {
    var data = {
      "platform": "LinkedIn"
    }
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };

    const resp = await axios.post(apiUrl + "deletefbtoken", data, headers);
    if (resp.data.status === "success") {
      fetchUsers();
      window.open("https://www.linkedin.com/m/logout/", "_blank");
    } else {
      Swal.fire({
        text: resp.data.message,
        icon: "error",
        width: "350px",
        confirmButtonText: "Ok",
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: { popup: "small-icon-alert" },
      });
    }

  };

  const logoutFromTwitter = async() => {
    var data = {
      "platform": "Twitter"
    }
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };

    const resp = await axios.post(apiUrl + "deletefbtoken", data, headers);
    if (resp.data.status === "success") {
      fetchUsers();
      // window.open("https://www.linkedin.com/m/logout/", "_blank");
    } else {
      Swal.fire({
        text: resp.data.message,
        icon: "error",
        width: "350px",
        confirmButtonText: "Ok",
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: { popup: "small-icon-alert" },
      });
    }
  }

  const logoutFromyoutube = async() => {
    var data = {
      "platform": "Youtube"
    }
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };

    const resp = await axios.post(apiUrl + "deletefbtoken", data, headers);
    if (resp.data.status === "success") {
      fetchUsers();
      // window.open("https://www.linkedin.com/m/logout/", "_blank");
    } else {
      Swal.fire({
        text: resp.data.message,
        icon: "error",
        width: "350px",
        confirmButtonText: "Ok",
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: { popup: "small-icon-alert" },
      });
    }
  }
  

  const handlelogout = (data) => {
    console.log('handlelogout >>', data);
    if(data?.platform == "Facebook") {
      handleFBLogout(data?.accesstokens);
    } else if(data?.platform == "Instagram") {
      handleInstaLogout()
    } else if(data?.platform == "LinkedIn") {
      logoutFromLinkedIn();
    } else if(data?.platform == "Twitter") {
      logoutFromTwitter();
    } else if(data?.platform == "Youtube") {
      logoutFromyoutube();
    }
  }

  const getlonglivetoken = async(shorttoken) => {
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    var data = {
      'shorttoken': shorttoken
    }
    const resp = await axios.post(apiUrl + "get-long-lived-token", data, headers);
            if (resp.data.status === "success") {
              var prevdata = resp.data.data;
              if(prevdata?.access_token) {
                  storeinstatoken(prevdata?.access_token);
              }
            } else {
              Swal.fire({
                title: '',
                text: "Something went wrong, try again",
                icon: 'error',
                customClass: {
                  icon: 'custom-swal-icon' // Apply the custom class
                },
                width: '350px',
                confirmButtonText: 'Ok',
            confirmButtonColor: "rgb(59, 151, 196)",
                customClass: {
                    popup: "small-icon-alert",
                  },
              });
            }

  } 

  const handleinstagramlogin = () => {

    window.FB.login(
    function (response) {
        if (response.authResponse) {
          const accessToken = response.authResponse.accessToken;
          console.log("Access Token >>", response);
          console.log('response.authResponse >>', response.authResponse);
          console.log("Access Token >>", accessToken);
          if(accessToken) {
            getlonglivetoken(accessToken);
          }
        } else {
          Swal.fire({
            title: '',
            text: "User cancelled login or did not authorize.",
            icon: 'error',
            customClass: {
              icon: 'custom-swal-icon' // Apply the custom class
            },
            width: '350px',
            confirmButtonText: 'Ok',
        confirmButtonColor: "rgb(59, 151, 196)",
            customClass: {
                popup: "small-icon-alert",
              },
          });
        }
      },
      // --- CORRECTED SCOPES ---
      { scope: "public_profile,email,pages_show_list,pages_read_engagement,pages_read_user_content,pages_manage_posts,pages_manage_metadata,read_insights, instagram_basic, instagram_content_publish, instagram_manage_insights" }
    );
  }

  const handletwitterlogin = () => {
    const clientId = "NzZGbG9ZSVM2Q3lsNUlHUkFiemQ6MTpjaQ";
    const redirectUri = encodeURIComponent("https://marketing.consulthagnos.in.net/admin/twitter-callback");
    const state = "randomstring"; // generate securely
    const scope = "tweet.read tweet.write users.read offline.access media.write";

    window.location.href = `https://twitter.com/i/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}&code_challenge=challenge&code_challenge_method=plain`;
  }

  const Innerapp = () => {
    // const handleLoginSuccess = async (credentialResponse) => {
    //   try {
    //     const idToken = credentialResponse.credential;
    //     console.log('credentialResponse >>', credentialResponse);
    //     console.log('idToken >>', idToken);

    //     const headers = {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: "Bearer " + userdata?.token,
    //       },
    //     };

    //     var data = {
    //       "idtoken": idToken
    //     }
      
    //     const resp = await axios.post(apiUrl + "youtube-exchangetoken", data, headers);
    //     if (resp.data.status === "success") {
    //     //    fetchUsers();
    //     } else {
    //       Swal.fire({
    //         text: resp.data.message,
    //         icon: "error",
    //         width: "350px",
    //         confirmButtonText: "Ok",
    //         confirmButtonColor: "rgb(59, 151, 196)",
    //         customClass: { popup: "small-icon-alert" },
    //       });
    //     }


    //   } catch (err) {
    //     console.error(err);
    //   }
    // };
    // return (
    //   <GoogleLogin
    //     onSuccess={handleLoginSuccess}
    //     onError={() => console.log("Login Failed")}
    //     useOneTap
    //     scope="https://www.googleapis.com/auth/youtube.upload https://www.googleapis.com/auth/youtube.readonly"
    //   />
    // )
    const login = useGoogleLogin({
      flow: "implicit", // important to get access_token
      scope: "https://www.googleapis.com/auth/youtube.upload https://www.googleapis.com/auth/youtube.readonly",
      onSuccess: async (tokenResponse) => {
        console.log("tokenResponse >>", tokenResponse);

             const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
  
        // send access_token to Laravel
        const resp = await axios.post(apiUrl + "youtube-exchangetoken", {
          access_token: tokenResponse.access_token,
        }, headers);
  
        console.log(resp.data);
      },
      onError: () => console.log("Login Failed"),
    });
  
    return (
      <button onClick={() => login()}>Connect YouTube</button>
    );
  }

  const handleyoutubelogin = async() => {
    // setutubeloginmodal(true);
    // const oauthUrl =
    //   "https://accounts.google.com/o/oauth2/v2/auth?" +
    //   new URLSearchParams({
    //     client_id: GOOGLE_CLIENT_ID,
    //     redirect_uri: REDIRECT_URI,
    //     response_type: "code", // request an authorization code
    //     scope: SCOPES,
    //     access_type: "offline", // ensures refresh_token
    //     prompt: "consent", // forces refresh_token every time
    //   });

    // window.location.href = oauthUrl; // redirect user to Google consent screen

    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };

    const res = await axios.get(apiUrl + "auth/youtube/login", headers);
    if(res?.data?.status == "success") {
      window.location.href = res?.data.url; 
    } else if (res.data.message === 'invalid user') {
            dispatch({ type: 'userdata', payload: {} });
            navigate('/login');
          } else {
            Swal.fire({
              text: res.data.message,
              icon: 'error',
              width: '350px',
              confirmButtonText: 'Ok',
              confirmButtonColor: 'rgb(59, 151, 196)',
              customClass: { popup: 'small-icon-alert' },
            });
          }
    // window.location.href = resp.data.url; 

  }

  const handleLogin = (platform) => {
    console.log('handleLogin >>', platform);
    if(platform == "Facebook") {
      // handleFBLogin();
      handleinstagramlogin()
    } else if(platform == "LinkedIn") {
      handleLinkedinLogin();
      // logoutFromLinkedIn();
    } else if (platform == "Instagram") {
      handleinstagramlogin();
    } else if(platform == "Twitter") {
      handletwitterlogin();
    } else if(platform == "Youtube") {
      handleyoutubelogin();
    }
  };

  const storetokens = async(token) => {
    var data = {
      platform: "Facebook",
      accesstoken: token,
      accountname: "",
      pagesarr: []
    }

    // Wrap FB.api in Promise
  const getUserDetails = () => {
    return new Promise((resolve, reject) => {
      window.FB.api('/me', { fields: 'id,name' }, (response) => {
        if (response?.error) return reject(response.error);
        resolve(response);
      });
    });
  };

  const getPagesList = () => {
    return new Promise((resolve, reject) => {
      window.FB.api('/me/accounts', (response) => {
        if (response?.error) return reject(response.error);
        resolve(response.data || []);
      });
    });
  };

  try {
     // Wait for User Details
     const user = await getUserDetails();
     if (user?.name) {
       data.accountname = user.name;
     }
 
     // Wait for Pages
     const pages = await getPagesList();
     console.log('pages >>', pages);
     data.pagesarr = pages.map((page) => ({
       access_token: page.access_token,
       pageid: page.id,
       name: page.name,
       isselected: "false",
       platform: "Facebook",
       selectedhashtags: ""
     }));
 
     console.log("data >>", data);
 
     // Call API only after pages are fetched
     const headers = {
       headers: {
         "Content-Type": "application/json",
         Authorization: "Bearer " + userdata?.token,
       },
     };
 
     const resp = await axios.post(apiUrl + "updatenewfbtoken", data, headers);
     if (resp.data.status === "success") {
       fetchUsers();
     } else {
       Swal.fire({
         text: resp.data.message,
         icon: "error",
         width: "350px",
         confirmButtonText: "Ok",
         confirmButtonColor: "rgb(59, 151, 196)",
         customClass: { popup: "small-icon-alert" },
       });
     }
  }
catch (err) {
  alert(err.message || "Something went wrong");
}
  }

  const storeinstatoken = async(token) => {
    var fbdata = {
        platform: "Facebook",
        accesstoken: token,
        accountname: "",
        pagesarr: []
      }
      var instadata = {
        platform: "Instagram",
        accesstoken: token,
        accountname: "",
        pagesarr: []
      }
      const getUserDetails = () => {
        return new Promise(async(resolve, reject) => {
            const resp = await axios.get("https://graph.facebook.com/v21.0/me?access_token="+token);
            if(resp?.error) {
                return reject(resp.error)
            } else {
                resolve(resp?.data);
            }
        });
      };

      const getAllPagesList = () => {
        return new Promise(async(resolve, reject) => {
            const resp = await axios.get("https://graph.facebook.com/v21.0/me/accounts?access_token="+token);
            if(resp?.error) {
                return reject(resp.error)
            } else {
                resolve(resp?.data?.data);
            }
        });
      };

      try {
        // Wait for User Details
        const user = await getUserDetails();
        if (user?.name) {
          fbdata.accountname = user.name;
          instadata.accountname = user.name;
        }
    
        // Wait for Pages
        const pages = await getAllPagesList();
        console.log('pages >>', pages);

        // For instagram get pages list 
        var fbpagearr = [];
        var fbinstapagearr = [];
        for(var i = 0; i < pages?.length; i++) {
            var obj = {};
            obj['access_token'] = pages[i]?.access_token;
            obj['pageid'] = pages[i]?.id;
            obj['name'] = pages[i]?.name;
            obj['isselected'] = "false";
            obj['platform'] = "Facebook";
            obj['selectedhashtags'] = "";
            fbpagearr.push(obj);

            // check for instagram
            try {
                var url = "https://graph.facebook.com/v21.0/"+pages[i]?.id+"?fields=instagram_business_account&access_token="+token;
                let instaresp = await axios.get(url);
                var prevdata = instaresp?.data;
                if(prevdata.hasOwnProperty("instagram_business_account")) {
                    var instapageid = prevdata?.instagram_business_account?.id;
                    var instaurl = "https://graph.facebook.com/v21.0/"+instapageid+"?fields=name&access_token="+token;
                    let instadetailsresp = await axios.get(instaurl);
                    // console.log('instadetailsresp >>', instadetailsresp?.data);
                    var instaobj = {};
                    instaobj['access_token'] = token;
                    instaobj['linked_fb_id'] = pages[i]?.id;
                    instaobj['pageid'] = instapageid;
                    instaobj['name'] = instadetailsresp?.data?.name;
                    instaobj['isselected'] = "false";
                    instaobj['platform'] = "Instagram";
                    instaobj['selectedhashtags'] = "";
                    fbinstapagearr.push(instaobj);
                } else {

                }
                

            } catch (err) {
                console.error("Check for instagram accounts err >>", err);
            }
        }
        fbdata.pagesarr = fbpagearr;
        instadata.pagesarr = fbinstapagearr;
    
        console.log("fbdata >>", fbdata);
        console.log("instadata >>", instadata);

        const headers = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + userdata?.token,
            },
          };
        
          const resp = await axios.post(apiUrl + "updatenewfbtoken", fbdata, headers);
     if (resp.data.status === "success") {
    //    fetchUsers();
     } else {
       Swal.fire({
         text: resp.data.message,
         icon: "error",
         width: "350px",
         confirmButtonText: "Ok",
         confirmButtonColor: "rgb(59, 151, 196)",
         customClass: { popup: "small-icon-alert" },
       });
     }

     if(instadata?.length > 0) {
        const resp = await axios.post(apiUrl + "updatenewfbtoken", instadata, headers);
     if (resp.data.status === "success") {
       fetchUsers();
     } else {
       Swal.fire({
         text: resp.data.message,
         icon: "error",
         width: "350px",
         confirmButtonText: "Ok",
         confirmButtonColor: "rgb(59, 151, 196)",
         customClass: { popup: "small-icon-alert" },
       });
     }
     } else {
        fetchUsers();
     }


     const instresp = await axios.post(apiUrl + "updatenewfbtoken", instadata, headers);
     if (resp.data.status === "success") {
       fetchUsers();
     } else {
       Swal.fire({
         text: resp.data.message,
         icon: "error",
         width: "350px",
         confirmButtonText: "Ok",
         confirmButtonColor: "rgb(59, 151, 196)",
         customClass: { popup: "small-icon-alert" },
       });
     }

      } catch(err) {
        alert(err.message || "Something went wrong");
      }

  }

  const handledeletefbtoken = async() => {
    var data = {
      "platform": "Facebook"
    }
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };

    const resp = await axios.post(apiUrl + "deletefbtoken", data, headers);
    if (resp.data.status === "success") {
      fetchUsers();
    } else {
      Swal.fire({
        text: resp.data.message,
        icon: "error",
        width: "350px",
        confirmButtonText: "Ok",
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: { popup: "small-icon-alert" },
      });
    }
 }

 const handleFBLogin = () => {
     window.FB.login(
       function (response) {
         if (response.authResponse) {
           const accessToken = response.authResponse.accessToken;
           console.log("Access Token >>", response);
           console.log('response.authResponse >>', response.authResponse);
           console.log("Access Token >>", accessToken);
          //  getUserDetails();
          // getPagesList();
           if(accessToken) {
            storetokens(accessToken);
           }
           
   
           // You can now use this token to call Graph API
         } else {
           Swal.fire({
             title: '',
             text: "User cancelled login or did not authorize.",
             icon: 'error',
             customClass: {
               icon: 'custom-swal-icon' // Apply the custom class
             },
             width: '350px',
             confirmButtonText: 'Ok',
         confirmButtonColor: "rgb(59, 151, 196)",
             customClass: {
                 popup: "small-icon-alert",
               },
           });
         }
       },
       // --- CORRECTED SCOPES ---
       { scope: "public_profile,email,pages_show_list,pages_read_engagement,pages_read_user_content,pages_manage_posts,pages_manage_metadata,read_insights" }
     );
   }

  const handleFBLogout = (accesstoken) => {
    window.FB.logout(function(response) {
      console.log("User logged out", response);
    });

    fetch(`https://graph.facebook.com/me/permissions?access_token=${accesstoken}`, {
      method: 'DELETE'
    })
    .then(res => res.json())
    .then(data => {
      console.log('Token revoked:', data)
      handledeletefbtoken();
    })
    .catch(err => console.error(err));
  }

  const handleInstaLogout = async() => {
    var data = {
      "platform": "Instagram"
    }
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };

    const resp = await axios.post(apiUrl + "deletefbtoken", data, headers);
    if (resp.data.status === "success") {
      fetchUsers();
      // window.open("https://www.linkedin.com/m/logout/", "_blank");
    } else {
      Swal.fire({
        text: resp.data.message,
        icon: "error",
        width: "350px",
        confirmButtonText: "Ok",
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: { popup: "small-icon-alert" },
      });
    }
  }

 

  const handleshowpagesmodal = (data) => {
    console.log('data >>', data);
    setselectedpageobj(data);
    setTimeout(() => {
      setshowmodal(true);
    }, 1000);
    
  }

  const fetchUsers = async () => {
    setShowLoading(true);
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + userdata?.token,
      },
    };

    try {
      const res = await axios.get(apiUrl + 'getallplatformdetails', headers);
      if (res.data.status === 'success') {
        // const prevdata = sampledata;
        var prevfetcheddata = res?.data?.data;
        var newarr = [];
        var prevdata = Object.keys(sampleplaftormsobj);
        for(var i = 0; i < prevdata?.length; i++) {
          if(prevfetcheddata[prevdata[i]]) {
            console.log('matched!!');
            // if fetched
            var obj = {};
            obj['platform'] = prevdata[i];
            obj['status'] = "true";
            obj['accountName'] = prevfetcheddata[prevdata[i]]?.accountname;
            obj['accessPages'] = prevfetcheddata[prevdata[i]]?.pagesarr ? JSON.parse(prevfetcheddata[prevdata[i]]?.pagesarr) : [];
            obj['accesstokens'] = prevfetcheddata[prevdata[i]]?.accesstoken;
            // console.log('matched obj >>', obj);
            newarr.push(obj);
          } else {
            var obj = {};
            obj['platform'] = prevdata[i];
            obj['status'] = "false";
            obj['accountName'] = null;
            obj['accessPages'] = [];
            obj['accesstokens'] = null;
            // console.log('unmatched obj >>', obj);
            newarr.push(obj);
          }
        }

        console.log('newarr >>', newarr)


        if (newarr?.length > 0) {
          const columnsarr = [];
          const hidecolumns = ['userid', 'updated_at', 'created_at', 'status', 'accesstokens'];
          const hidefilters = [];
          const columns = Object.keys(newarr[0]);

          for (let i = 0; i < columns.length; i++) {
            if (!hidecolumns.includes(columns[i])) {
              var obj = {};
              obj.field = columns[i];
              obj.cellStyle = {color: '#000', fontWeight: 600}
          
              obj.cellClass = 'inventorycell';
              obj.filter = true;
              obj.filterParams = {
                filterOptions: ["contains"],
                maxNumConditions: 1,
              }
          obj.width = 250;
              if (columns[i] == "accessPages") {
                
          obj.cellRenderer = (props) => {
            return (
              <div className="d-flex" style={{ marginTop: 3 }}>
                {/* <img src={customer_table} className="customerrowimage" /> */}
                {props?.data?.accessPages?.length > 0 ? (
                  <div className="customernamediv" onClick={() => {handleshowpagesmodal(props?.data)}} style={{cursor: 'pointer'}}>
                    <p>{props?.data?.accessPages?.length}</p>
                  </div>
                ) : null}
              </div>
            );
            
          }


            }  else {
             
            }
            columnsarr.push(obj);
            }
          }
          columnsarr.push({
            field: 'status',
            headerName: 'Status',
            cellRenderer: (props) => {
              console.log('check props data >>', props?.data?.platform)
              return (
                <>
                  {
                    props?.data?.status == "true" ?
                    <button className="btn btn-danger" onClick={() => {handlelogout(props?.data)}}>
                      Log out
                    </button> :
                    <button className="btn btn-success" onClick={() => {
                      handleLogin(props?.data?.platform)
                      }}>
                      Log In
                    </button>
                  }
                </>
                
              )
            },
          });
 //action
          // columnsarr.push({
          //   field: 'action',
          //   headerName: 'Action',
          //   cellRenderer: (props) => (
          //     <FontAwesomeIcon
          //       icon={faPenToSquare}
          //       className="sidebaricons"
          //       style={{ color: 'blue', cursor: 'pointer' }}
          //       onClick={() => {
          //         setSelectedUserData(props?.data);
          //         setShowUpdateUserModal(true);
          //       }}
          //     />
          //   ),
          // });

          setColDefs(columnsarr);
        setRowData(newarr);
        }
      } else if (res.data.message === 'invalid user') {
        dispatch({ type: 'userdata', payload: {} });
        navigate('/login');
      } else {
        Swal.fire({
          text: res.data.message,
          icon: 'error',
          width: '350px',
          confirmButtonText: 'Ok',
          confirmButtonColor: 'rgb(59, 151, 196)',
          customClass: { popup: 'small-icon-alert' },
        });
      }
    } catch (err) {
      alert(err.message);
    } finally {
      setShowLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
        // 1. Load Facebook SDK Script
        const loadFacebookSDK = () => {
          if (document.getElementById("facebook-jssdk")) return;
    
          const script = document.createElement("script");
          script.id = "facebook-jssdk";
          script.src = "https://connect.facebook.net/en_US/all.js";
          script.async = true;
          script.defer = true;
          document.body.appendChild(script);
    
          window.fbAsyncInit = function () {
            window.FB.init({
              appId: "615894628233072",
              cookie: true,
              xfbml: true,
              version: "v23.0",
            });
    
            console.log("Facebook SDK Initialized");
          };
        };
    
        loadFacebookSDK();
      }, []);


  return (
    <>
      <div className="ag-theme-quartz" style={{ height: 400, width: "100%" }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          pagination={true}
          paginationPageSize={10}
          rowHeight={50}
        />
      </div>

      {/*Add modal */}
      <Modal
        show={showmodal}
        onHide={() => setshowmodal(false)}
        size="md"
        className="custom-width-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 19 }}>
            {selectedpageobjRef.current?.accountName} |{" "}
            {selectedpageobjRef.current?.platform} page access
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="webadmin-modalmainbody">
            {selectedpageobjRef.current?.accessPages?.map((item, index) => {
              return (
                <div className="pagemodalmaindiv" key={index}>
                  <p>{item?.name}</p>
                </div>
              );
            })}
          </div>
        </Modal.Body>
      </Modal>

      {/* Youtube login modal */}
      <Modal
        show={utubeloginmodal}
        onHide={() => setutubeloginmodal(false)}
        size="md"
        className="custom-width-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 19 }}>
            Log in to Youtube
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="webadmin-modalmainbody">
            <GoogleOAuthProvider clientId="692688476295-sbkqbbmsrcli8h56caf2250prvc5l6lc.apps.googleusercontent.com">
              <Innerapp />
            </GoogleOAuthProvider>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PlatformAccountTableTest;
